import { requst } from '../config'

export const postUploadObstaclesBatchApi = file => {
    const url = `/map/border/uploadBatch`
    const formData = new FormData()
    formData.append('files', file)
    return requst({
        url,
        method: 'post',
        params: {
            type: 'kml',
        },
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    })
}

export const postObstaclesApi = (params, modalAddNew) => {
    if (modalAddNew) {
        return requst.post(`/map/obstacles/add`, params)
    } else {
        return requst.put(`/map/obstacles/update`, params)
    }
}

export const getObstaclesListApi = projectId => {
    const url = `/map/obstacles/list?projectId=${projectId}`
    return requst.get(url)
}

export const getObstaclesIdApi = id => {
    const url = `/map/obstacles/get?id=${id}`
    return requst.get(url)
}

export const getObstaclesDeleteApi = id => {
    const url = `/map/obstacles/delete?id=${id}`
    return requst.delete(url)
}

// 下载障碍物
export const getDownObstaclesIdApi = id => {
    const url = `/map/border/download/${id}`
    return requst.get(url, {
        responseType: 'blob',
    })
}
